import { BrowserModule, DomSanitizer } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { HighchartsChartModule } from 'highcharts-angular';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

import { SimulationTabComponent } from './components/simulation-tab/simulation-tab.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SimulationResultsComponent } from './components/simulation-results/simulation-results.component';

import { PixelService } from './services/pixel.service';
import { EweService } from './services/ewe.service';
import { FileSaverModule } from 'ngx-filesaver';


@NgModule({
  declarations: [
    AppComponent,
    SimulationTabComponent,
    SimulationResultsComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,

    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatButtonModule,
    FileSaverModule,

    BsDatepickerModule.forRoot(),
    TooltipModule.forRoot(),
    LeafletModule,
    HighchartsChartModule
  ],
  providers: [
    PixelService,
    EweService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(matIconRegistry: MatIconRegistry, domSanitizer: DomSanitizer) {
    matIconRegistry.addSvgIconSet(
      domSanitizer.bypassSecurityTrustResourceUrl('./assets/mdi.svg')
    );
  }
}
